import axios from "axios";

export default axios.create({
    baseURL: 'cheapStudyApiSettings' in window ? cheapStudyApiSettings.root : '/',
    timeout: 5000,
    headers: {'X-WP-Nonce': 'cheapStudyApiSettings' in window ? cheapStudyApiSettings.nonce : ''}
});